import EventEmitter from 'eventemitter3';

export const createEventEmitter = () => new EventEmitter();
